export default __webpack_public_path__ + "static/media/5m-light.8dab2269.svg";